<template>
  <div class="rfv-periods">
    <div class="left-side">
      <h2>Período referência</h2>
      <p>{{ formattedPdfDates.referenceDates }}</p>
    </div>
    <div class="right-side">
      <h2>Período analisado</h2>
      <p>{{ formattedPdfDates.currentDates }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RfvPeriods',
  props: {
    formattedPdfDates: {
      type: Object,
      default: () => ({
        currentDates: '',
        referenceDates: '',
      }),
    },
  },
}
</script>

<style lang="scss" scoped>
.rfv-periods {
  gap: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 64px;
  width: 100%;

  h2 {
    margin-bottom: 2px;
    line-height: 120%;
  }

  p {
    margin-bottom: 0;
    line-height: 120%;
  }

  .left-side {
    h2 {
      color: $cinza-l20;
    }

    p {
      color: $cinza-0;
    }
  }

  .right-side {
    h2 {
      color: $marca-0-l40;
    }

    p {
      color: $marca-0-l30;
    }
  }
}
</style>
